import { render, staticRenderFns } from "./PublishTrainingCourses.vue?vue&type=template&id=0972a328&"
import script from "./PublishTrainingCourses.vue?vue&type=script&lang=js&"
export * from "./PublishTrainingCourses.vue?vue&type=script&lang=js&"
import style0 from "./PublishTrainingCourses.vue?vue&type=style&index=0&id=0972a328&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports